
import { useState } from 'preact/hooks';
import { MaterialSlotPatternConfig } from '../../../managers/MaterialSlotPatternConfig';

interface MaterialsPanelProps {
  patternConfigs: MaterialSlotPatternConfig[];
  onMaterialChange: (slotId: string, optionId: string) => void;
}

export const MaterialsPanel = ({ patternConfigs, onMaterialChange }: MaterialsPanelProps) => {
  // Group configs by object name
  const byObject = new Map<string, MaterialSlotPatternConfig[]>();
  for (const config of patternConfigs) {
    const objName = config.objectName || 'Other';
    if (!byObject.has(objName)) {
      byObject.set(objName, []);
    }
    byObject.get(objName)!.push(config);
  }

  const [openGroups, setOpenGroups] = useState<Set<string>>(
    new Set([...byObject.keys()][0] ? [[...byObject.keys()][0]] : [])
  );

  const toggleGroup = (objectName: string) => {
    setOpenGroups(prev => {
      const next = new Set(prev);
      if (next.has(objectName)) {
        next.delete(objectName);
      } else {
        next.add(objectName);
      }
      return next;
    });
  };

  return (
    <div class="visualizer-panel visualizer-material-panel">
      <div class="visualizer-panel-title" style={{ padding: '12px 12px 6px 12px' }}>
        Material Customization
      </div>

      {[...byObject.entries()].map(([objectName, configs]) => {
        const isOpen = openGroups.has(objectName);

        return (
          <div key={objectName} class="visualizer-object-group">
            <div
              class="visualizer-object-header"
              onClick={() => toggleGroup(objectName)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                <line x1="12" y1="22.08" x2="12" y2="12"></line>
              </svg>
              <span>{objectName}</span>
              <svg
                class="visualizer-object-chevron"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                style={{ transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)' }}
              >
                <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>

            {isOpen && (
              <div class="visualizer-object-content">
                {configs.map((config) => (
                  <div key={config.id} class="visualizer-material-item">
                    <div class="visualizer-material-name">{config.name}</div>
                    
                    {/* Dropdown selector */}
                    <select
                      value={config.selectedOptionId || ''}
                      onChange={(e) => onMaterialChange(config.id, (e.target as HTMLSelectElement).value)}
                      style={{
                        width: '100%',
                        padding: '6px',
                        borderRadius: '4px',
                        border: '1px solid #ddd',
                        fontSize: '12px',
                        background: 'white',
                      }}
                    >
                      {config.options.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
